import config from "config/config";
import getTokens from "api/getTokens";

const  { baseUrl, clientUrl } = config;

/* *********************
  email
  password
********************** */

export default function getClients(page, limit = 50, orderBy = "", id = "", name = "", vatId = "") {
  let order = "sortDisabled";
  if (orderBy === "name") {
    order = "name:asc";
  } else if (orderBy === "nameReverse") {
    order = "name:desc";
  } else if (orderBy === "vatId") {
    order = "vatId:asc";
  } else if (orderBy === "vatIdReverse") {
    order = "vatId:desc";
  }
  const endpoint = `${baseUrl}/v1/clients/?limit=${limit}&page=${page}&sortBy=${order}&id=${id}&name=${name}&vatId=${vatId}`;
  let access = "";
  const tokens = getTokens();
  if (tokens && tokens.access && tokens.access.token) {
    access = tokens.access.token;
  } else {
    window.location.href = "/login";
  }
  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
      Authorization: `bearer ${access}`,
    },
  };
  // console.log('login endpoint', {endpoint, BODY });
  return fetch(endpoint, options)
    .then((response) => {
      // console.log('login response', response);
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        throw new Error();
      }
      return response.json();
    })
    .catch((e) => {
      // eslint-disable-next-line
      console.log("error", e);
    });
}
